import HomeScreen from "./Landing/HomeScreen";
import HeaderBar from "./Components/Static/HeaderBar";
import Footer from "./Components/Static/Footer";
import useStore from './state-files/zustondStoreStates';

export const Layout = ({ }) => {
  const { setCommunityId } = useStore();

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header - AppBar */}
      <HeaderBar isLoggedIn={false} setCommunityId={setCommunityId} />

      {/* Main Content Section */}
      <HomeScreen />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};
